<odx-modal-header>
  <odx-area-header i18n="@@modal.deleteCloudProjects.header">Cloudprojekte löschen</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  @if (cloudProjects$ | async; as cloudProjects) {
    @if (cloudProjects.length) {
      <p i18n="@@modal.deleteCloudProjects.instructions">
        Klicken Sie auf das entsprechende Icon, um das gewünschte Projekt aus Ihrer Cloud zu löschen.
      </p>
    }
    <app-delete-cloud-project-odx-table [cloudProjectMetadata]="cloudProjects" (projectSelected)="onClickDelete($event)">
    </app-delete-cloud-project-odx-table>
  } @else {
    <p [odxLoadingSpinner]="true" [odxLoadingSpinnerMinHeight]="500"></p>
  }
</odx-modal-content>
